import { render, staticRenderFns } from "./availabilityShiftList.vue?vue&type=template&id=295369eb&"
import script from "./availabilityShiftList.vue?vue&type=script&lang=js&"
export * from "./availabilityShiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports